import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserLoginWithSF } from "../../../hooks/react-query/auth/useUserLogin";
// import { useCookies } from "react-cookie";
import styles from "./auth-login-with-sf-callback.module.scss";
import ClockLoader from "react-spinners/ClockLoader";
import { useSFLogin } from "../../../hooks/react-query/auth/useSFLogin";
import { latVar, redirectUri } from "../../../utils/utils";

const LoginSalesForceAuthCallback = (): JSX.Element => {
  const [message, setMessage] = useState("Authenticating....");
  const hasCalledAPI = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const [cookie, setCookie, removeCookie] = useCookies(["redirect"]);
  const params = new URLSearchParams(location.search);
  const code = params.get("code");
  const LoginMutation = useUserLoginWithSF(
    (data) => {
      // cookie?.redirect?.length > 0
      // ? navigate(cookie.redirect) :
      navigate(
        `/properties?lat=${latVar.lat}&lng=${latVar.lng}&zoom=${latVar.zoom}&state=CA&status=Active`
      );
      // removeCookie("redirect");
    },
    (error) => {
      navigate("/");
      console.error("Login failed", error);
    }
  );

  const SFLoginMutation = useSFLogin(
    (data) => {
      LoginMutation.mutate({
        access_token: data.access_token,
        refresh_token: data.refresh_token,
        signature: data.signature,
        scope: data.scope,
        instance_url: data.instance_url,
        id: data.id,
        token_type: data.token_type,
        issued_at: data.issued_at ? +data.issued_at : 0
      });
    },
    (error) => {
      navigate("/");
      console.error("Login failed", error);
    }
  );

  useEffect(() => {
    if (code && !hasCalledAPI.current) {
      hasCalledAPI.current = true; // Mark the API as called
      setMessage("Loading, Please wait...");
      SFLoginMutation.mutate({
        code: code,
        redirect_uri: redirectUri
      });
    } else if (!code) {
      setMessage("Invalid user");
      navigate("/");
    }
  }, [code, SFLoginMutation, navigate]);

  return (
    <div className={styles.container}>
      <div className={styles.imgBox}>
        <ClockLoader color="#7d7d7d" size={100} />
      </div>
      <div className={styles.heading}>{message}</div>
    </div>
  );
};

export default LoginSalesForceAuthCallback;
